/*
 * @Descripttion:
 * @version:
 * @Author: lzs
 * @Date: 2021-11-16 09:18:11
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-08-16 10:13:20
 */
/**
 * 统计数据
 */
const quantity = {
  getQuantity: "/api/getQuantity", //查询统计量
  getQuantity2: "/api/getQuantity2", //查询统计量
  getQuantitySum: "/api/getQuantitySum", //查询统计量
  getQuantitySumHour: "/api/getQuantitySumHour", //查询统计量
  getQuantitySumDay: "/api/getQuantitySumDay", //查询统计量
  getQuantitySumWeek: "/api/getQuantitySumWeek", //查询统计量
  getQuantitySumMonth: "/api/getQuantitySumMonth", //查询统计量
  getQuantitySumYear: "/api/getQuantitySumYear", //查询统计量
  getQuantitySum2: "/api/getQuantitySum2", //查询统计量
  getQuantitySumHour2: "/api/getQuantitySumHour2", //查询统计量
  getQuantitySumDay2: "/api/getQuantitySumDay2", //查询统计量
  getQuantitySumWeek2: "/api/getQuantitySumWeek2", //查询统计量
  getQuantitySumMonth2: "/api/getQuantitySumMonth2", //查询统计量
  getQuantitySumYear2: "/api/getQuantitySumYear2", //查询统计量
  getQuantityHour: "/api/getQuantityHour", //查询统计量
  getQuantityMonth: "/api/getQuantityMonth", //查询统计量
  getQuantityYear: "/api/getQuantityYear", //查询统计量
  getQuantityHour2: "/api/getQuantityHour2", //查询统计量
  getQuantityMonth2: "/api/getQuantityMonth2", //查询统计量
  getQuantityYear2: "/api/getQuantityYear2", //查询统计量
  getQuantityHour3: "/api/getQuantityHour3", //查询统计量
  getQuantityMonth3: "/api/getQuantityMonth3", //查询统计量
  getQuantityYear3: "/api/getQuantityYear3", //查询统计量
  getQuantityDay: "/api/getQuantityDay", //查询统计量
  getQuantityWeek: "/api/getQuantityWeek", //查询统计量
  getQuantityDay2: "/api/getQuantityDay2", //查询统计量
  getQuantityWeek2: "/api/getQuantityWeek2", //查询统计量
  getQuantityDay3: "/api/getQuantityDay3", //查询统计量
  getQuantityWeek3: "/api/getQuantityWeek3", //查询统计量
  getQuantityDay4: "/api/getQuantityDay4", //查询统计量
  getQuantityWeek4: "/api/getQuantityWeek4", //查询统计量
  getQuantityDay5: "/api/getQuantityDay5", //查询统计量
  getQuantityWeek5: "/api/getQuantityWeek5", //查询统计量
  getQuantityByClassHour: "/api/getQuantityByClassHour", //根据分类分组查用量
  getQuantityByClassDay: "/api/getQuantityByClassDay", //根据分类分组查用量
  getQuantityByClassMonth: "/api/getQuantityByClassMonth", //根据分类分组查用量
  getQuantityByClassYear: "/api/getQuantityByClassYear", //根据分类分组查用量
  getQuantityByClassHour2: "/api/getQuantityByClassHour2", //根据分类分组查用量
  getQuantityByClassDay2: "/api/getQuantityByClassDay2", //根据分类分组查用量
  getQuantityByClassMonth2: "/api/getQuantityByClassMonth2", //根据分类分组查用量
  getQuantityByClassYear2: "/api/getQuantityByClassYear2", //根据分类分组查用量
  refreezeQuantity: "/api/refreezeQuantity", //重新冻结数据
  refreezeQuantity2: "/api/refreezeQuantity2", //重新冻结数据
  getSpentMoneyDay: "/api/getSpentMoneyDay/v2",
  getSpentMoneyMonth: "/api/getSpentMoneyMonth/v2",
  getSpentMoneyYear: "/api/getSpentMoneyYear/v2",
};

export default quantity;
